export default function useFilterTrackingEvent() {
  const { trackEvent } = useGtmTrack()

  const trackClearAllFilterClicked = () => {
    trackEvent({
      event: 'click',
      params: {
        event_category: 'Filters',
        event_action: 'Clear',
        event_label: 'CLEAR ALL FILTERS',
      },
    })
  }

  const trackFilterClicked = (
    filterValue: string[],
    params: {
      value: string
      slugUrl: string
      filterIndex: number
      filterCategoryIndex: number
      type: string
    }
  ) => {
    trackEvent({
      event: 'click',
      params: {
        event_category: 'Filters',
        event_action: `Click ${params.type} Filter`,
        event_label: params.value,
        cm8: filterValue.includes(params.slugUrl) ? 1 : -1,
        cd48: params.filterIndex,
        cd49: params.filterCategoryIndex,
      },
    })
  }

  return { trackClearAllFilterClicked, trackFilterClicked }
}
